// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import * as GmapVue  from 'gmap-vue'
import GmapCluster from "gmap-vue/dist/components/cluster";
import VueGoogleHeatmap from 'vue-google-heatmap';
/* IE Support start*/
import 'core-js/es6/number';
import 'core-js/shim';
/* IE Support End*/

import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-good-table/dist/vue-good-table.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

Vue.use(GmapVue, {
	load: {
	  key: process.env.MAP_API_KEY,
	  installComponents: true
	}
  });
  Vue.component('GmapCluster', GmapCluster)
  Vue.use(GmapVue, {
	apiKey: process.env.MAP_API_KEY,
  });
  export const loadedGoogleMapsAPI = new Promise( (resolve,reject) => {

	window['GoogleMapsInit'] = resolve;

	let GMap = document.createElement('script');

	GMap.setAttribute('src',
   `https://maps.googleapis.com/maps/api/js?key=${process.env.MAP_API_KEY}&callback=GoogleMapsInit&libraries=visualization`);

	document.body.appendChild(GMap);
});
/* eslint-disable no-new */
new Vue({
  	el: '#app',
  	router,
  	components: { App },
  	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js